import Vue from 'vue';
import Tip from './index.vue';

let GlobalTipConstrutor = Vue.extend(Tip);
let instance;

const globalTip = function (options = {}) {
  if (typeof options === 'string') {
    options = {
      content: options,
      onClose: () => {},
      onConfirm: () => {},
    };
  }

  instance = new GlobalTipConstrutor({
    data: options,
  });

  document.body.appendChild(instance.$mount().$el);
};

export default globalTip;
